<button *ngIf="!href" [class]="classList" (click)="sameProduct()">{{text}}</button>
<a *ngIf="href" [class]="classList" target="_blank" (click)="eventHandler()" [href]="href">{{text}}</a>
